import { Context, createContext, useContext, useEffect } from "@lukekaalim/act";

export type BeatCallback = (
  now: DOMHighResTimeStamp,
  delta: DOMHighResTimeStamp,
  frame: number,
) => void

export type BeatController = {
  subscribe(subscriber: BeatCallback): () => void;
  tick(now: DOMHighResTimeStamp): void;
  context: Context<BeatController["subscribe"]>
}

type BeatSpecification = {

}

type BeatRef = {

}

export const useBeat = (beat: BeatController, subscriber?:BeatCallback) => {
  const subscribe = useContext(beat.context);

  useEffect(() => {
    if (subscriber) {
      return subscribe(subscriber);
    }
  }, [subscriber])

  return subscribe
};

export const createBeat = (): BeatController => {
  const subscribers = new Map<Symbol, BeatCallback>();

  let lastTick = 0;
  let frame = 0;

  const subscribe = (subscriber: BeatCallback): () => void => {
    const symbol = Symbol();

    subscribers.set(symbol, subscriber);
    return () => void subscribers.delete(symbol);
  }

  const tick = (now: DOMHighResTimeStamp) => {
    const delta = lastTick && now - lastTick;
    lastTick = now;
    const currentFrame = frame++;
    for (const subscriber of subscribers.values()) {
      try {
        subscriber(now, delta, currentFrame)
      } catch (error) {
        console.warn(error)
      }
    }
  }

  const context = createContext(subscribe);

  return {
    context,
    subscribe,
    tick,
  }
}